import { FC, useMemo, useCallback } from 'react';

import { ButtonGroup } from '@beeline/design-system-react/extracted-styles';
import {
  ButtonGroupOptionsArray,
  ButtonGroupOption,
} from '@beeline/design-system-react/types/components/ButtonGroup/ButtonGroup.types';

import { TooltipWrapper } from 'src/components/TooltipWrapper/TooltipWrapper';

export enum Mode {
  Sharing = 'sharing',
  Booking = 'booking',
}

export interface RoomBookingPageModeSwitcherProps {
  mode: Mode;
  setMode: (mode: Mode) => void;
  bookingIsEnabled: boolean;
}

export const bookingDisabledReason = 'Место должно быть расшарено';

const BookingWrapper: FC<{ children: JSX.Element }> = ({ children }) => (
  <TooltipWrapper title={bookingDisabledReason}>{children}</TooltipWrapper>
);

export const RoomBookingPageModeSwitcher: FC<
  RoomBookingPageModeSwitcherProps
> = ({ mode, setMode, bookingIsEnabled }) => {
  const options = useMemo(
    (): ButtonGroupOptionsArray => [
      { id: Mode.Sharing, label: 'Шеринг' },
      {
        id: Mode.Booking,
        label: 'Бронь',
        disabled: !bookingIsEnabled,
        wrapper: bookingIsEnabled ? undefined : BookingWrapper,
      },
    ],
    [bookingIsEnabled],
  );

  const selectedOption = useMemo(
    (): ButtonGroupOption => ({
      id: mode,
    }),
    [mode],
  );

  const changeMode = useCallback(
    (option: ButtonGroupOption) => {
      setMode(option.id as Mode);
    },
    [setMode],
  );

  return (
    <ButtonGroup
      onChange={changeMode}
      options={options}
      selectedOption={selectedOption}
      alwaysSelected
      fullWidth
    />
  );
};
